import { useId } from "react";
import { FieldCard } from "./FieldCard";
import { ProgressMeter } from "./ProgressMeter";
import { selectProgress } from "../../engine/selectors";
import { t } from "../../i18n/strings";
import type { InterviewState } from "../../engine/types";

export function FieldPane({ state }: { state: InterviewState }) {
  const { filled, total } = selectProgress(state);
  const askableFields = state.template.fields.filter((f) => f.askable);
  const headingId = useId();

  return (
    <div
      role="region"
      aria-labelledby={headingId}
      className="flex h-full flex-col gap-3 overflow-hidden rounded-lg border border-border bg-paper-dim p-3"
    >
      <div>
        <h2 id={headingId} className="font-display text-lg text-ink">
          {t(state.locale, "fields.pane.heading")}
        </h2>
        <div className="mt-2">
          <ProgressMeter filled={filled} total={total} />
        </div>
      </div>
      <div className="flex-1 space-y-2 overflow-y-auto">
        {askableFields.map((field) => (
          <FieldCard key={field.id} field={field} state={state.fields[field.id]} locale={state.locale} />
        ))}
      </div>
    </div>
  );
}
